var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingapproval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.4872,
    height: 33.4872,
    rx: 16.7436,
    fill: "#4285F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11532_66436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1484 11.6953V8.45508C15.1484 7.85848 15.6319 7.375 16.2285 7.375C16.8251 7.375 17.3086 7.85848 17.3086 8.45508V11.6953C17.3086 12.2919 16.8251 12.7764 16.2285 12.7764C15.6319 12.7764 15.1484 12.2919 15.1484 11.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2129 10.041C21.6347 9.61917 22.3184 9.61914 22.7402 10.041C23.162 10.4628 23.162 11.1465 22.7402 11.5683L20.3906 13.9179C19.9687 14.3397 19.2851 14.3397 18.8632 13.9179C18.4414 13.4961 18.4414 12.8124 18.8632 12.3906L21.2129 10.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3281 15.4766C24.9247 15.4766 25.4092 15.96 25.4092 16.5566C25.4092 17.1532 24.9247 17.6367 24.3281 17.6367H21.0879C20.4913 17.6367 20.0078 17.1532 20.0078 16.5566C20.0078 15.96 20.4913 15.4766 21.0879 15.4766H24.3281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8633 19.1933C19.2851 18.7715 19.9688 18.7715 20.3906 19.1933L22.7402 21.543C23.162 21.9648 23.162 22.6485 22.7402 23.0703C22.3184 23.4921 21.6347 23.492 21.2129 23.0703L18.8633 20.7207C18.4414 20.2988 18.4414 19.6152 18.8633 19.1933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1484 24.6582V21.418C15.1484 20.8214 15.6319 20.3379 16.2285 20.3379C16.8251 20.3379 17.3086 20.8214 17.3086 21.418V24.6582C17.3086 25.2548 16.8251 25.7393 16.2285 25.7393C15.6319 25.7393 15.1484 25.2548 15.1484 24.6582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0566 19.1933C12.4785 18.7715 13.1621 18.7715 13.5839 19.1933C14.0057 19.6152 14.0057 20.2988 13.5839 20.7207L11.2343 23.0703C10.8125 23.4921 10.1288 23.4921 9.70699 23.0703C9.28515 22.6484 9.28519 21.9648 9.70699 21.5429L12.0566 19.1933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3672 15.4766C11.9638 15.4766 12.4482 15.96 12.4482 16.5566C12.4482 17.1532 11.9638 17.6367 11.3672 17.6367H8.12695C7.53036 17.6367 7.04688 17.1532 7.04688 16.5566C7.04688 15.96 7.53036 15.4766 8.12695 15.4766H11.3672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70702 10.041C10.1289 9.61915 10.8125 9.61915 11.2344 10.041L13.584 12.3906C14.0057 12.8125 14.0058 13.4961 13.584 13.918C13.1621 14.3398 12.4785 14.3397 12.0566 13.918L9.70702 11.5683C9.28516 11.1465 9.28516 10.4629 9.70702 10.041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11532_66436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4442,
    height: 19.4442,
    fill: "white",
    transform: "translate(6.5 6.83594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingapproval);
export default __webpack_public_path__ + "static/media/pending approval.d3962c93dffd548f36e68241e52841fe.svg";
export { ForwardRef as ReactComponent };